<template>
  <div class="container" >
    <!-- 场景视图 -->
    <div id="pano" @dblclick="dblclickScene" @click="clickScene"></div>
  </div>
</template>
<script>
export default {
  name: "Pano",
  data() {
    return {
      krpano: null,
      currentSceneId: 1, // 当前场景的索引
      isAddHotspotShow: false,
      sceneTourList: [], // 场景集合
      trackMouseId: null,
      clickMouseLocation: {}, // 点击的位置

    };
  },
  computed:{

  },
  mounted() {
    
    window.embedpano({
      swf: "vtour/tour.swf", // 有则表示加载 flash 引擎，如果设置 html5:only 则不需要该值
      xml: "vtour/tour.xml", // 启动时的配置文件
      target: "pano", // 要渲染到的目标容器 ID
      html5: "auto", // 如果有需要用到 flash ，可设置为 auto
      //id: "krpanoSWFObject", // 默认的 krpano 对象，每一个 viewer 对应唯一 id ，与 JS 交互时要用到
      mobilescale: 1.0, // 移动设备缩放，1 表示不缩放，默认 0.5
      passQueryParameters: true, // 是否接受 URL 传参，例如：tour.html?html5=only&startscene=scene2
      onready: (krpano_interface) => {
        this.krpano = krpano_interface;
        console.log(this.krpano,'this.krpano')

        setTimeout(() => {
          this.init();
        }, 500);
      },
      onerror: (error) => {
        console.log(error);
      },
      // consolelog: true, // 控制台日志
    });
    window.myGetXML = this.transmitXML;
    window.init = this.init;
    console.log(this.init,'this.init')

    // 绑定全局事件globalEvent
    this.$EventBus.$on('globalEvent', (obj,animationType = 1) => {
      this.goToScene(obj, animationType)
    });

    this.$EventBus.$on('gotoHotspot',(obj) => {
      let {ygtype, toH, toV, fov} = obj.type
      this.showTag(ygtype, toH, toV, fov)
    }) 


   
  },

  methods: {
    showTag(ygtype, toH, toV, fov){
      let count = this.krpano.get('hotspot.count');
      for(var i = 0; i <= count; i++){
         if(this.krpano.get('hotspot['+ i +'].ygtype') == ygtype){
            this.krpano.set('hotspot['+ i +'].visible', 'true');
            this.krpano.call(`lookto(${toH}, ${toV}, ${fov})`);
          } else {
            this.krpano.set('hotspot['+ i +'].visible', 'false');
          }          
      }
    },
    transmitXML(name) {
      console.log(name);
    },

    /**
     * 初始化数据
     *   可以等小行星动画结束在xml里调用
     */
    init() {
      this.krpano.get("xml.scene") // 获取当前的场景名
      this.krpano.get("scene").getItem(this.krpano.get("xml.scene")) // 获取当前场景
      this.sceneList = this.krpano.get("scene").getArray(); // 所有场景图
      console.log(this.sceneList,'sceneList')
      this.$EventBus.$on('playMusic',(obj) => {
        this.krpano.call(`peak_audio(${obj.goPlay})`);
    }) 

    },

    /**
     * 预览
     */
    preview() {
      window.open("vtour/tour.html");
    },

    /**
     * 获取切换场景的动画类型
     * @param {number} type  跳转的动画类型
     */
    getToggleSceneAnimation(type = 1) {
      let blend;
      switch (type) {
        case 1:
          // 从当前全景图混合/交叉淡入淡出到下一个全景图。
          blend = "BLEND(1.0, easeInCubic)";
          break;
        case 2:
          // 变焦混合
          blend = "ZOOMBLEND(2.0, 2.0, easeInOutSine)";
          break;
        case 3:
          // 打底黑
          blend = "COLORBLEND(2.0, 0x000000, easeOutSine)";
          break;
        case 4:
          // 打底白
          blend = "LIGHTBLEND(1.0, 0xFFFFFF, 2.0, linear)";
          break;
        case 5:
          // 从右到左
          blend = "SLIDEBLEND(1.0, 0.0, 0.2, linear)";
          break;
        case 6:
          // 从上到下
          blend = "SLIDEBLEND(1.0, 90.0, 0.01, linear)";
          break;
        case 7:
          // 沿对角线运动的
          blend = "SLIDEBLEND(1.0, 135.0, 0.4, linear)";
          break;
        case 8:
          // 开口圆
          blend = "OPENBLEND(1.0, 0.0, 0.2, 0.0, linear)";
          break;
        case 9:
          // 垂直性开合
          blend = "OPENBLEND(0.7, 1.0, 0.1, 0.0, linear)";
          break;
        case 10:
          // 水平性开合
          blend = "OPENBLEND(1.0, -1.0, 0.3, 0.0, linear)";
          break;
        case 11:
          // 椭圆+变焦
          blend = "OPENBLEND(1.0, -0.5, 0.3, 0.8, linear)";
          break;

        default:
          break;
      }

      return blend;
    },

    /**
     * 场景结合动画跳转
     * @param {number} obj 信息
     * @param {number} animationType  跳转的动画类型
     */
    goToScene(obj, animationType = 1) {
      console.log(obj,'obj')
      let blend = this.getToggleSceneAnimation(animationType);
      this.krpano.call(
        `peak_click_to_scene(${obj.peak_to_scene},${blend},${obj.hotspotName});`
      );

    },


    /**
     * 双击视图
     */
    dblclickScene() {
      console.log(this.getMouseLocation());
      this.clickMouseLocation = this.getMouseLocation();
      this.isAddHotspotShow = true;
    },

    /**
     * 单击视图
     */
    clickScene() {
      // 获取点击坐标
      const location = this.getMouseLocation();
      // 打印坐标信息
      console.log('点击坐标:', {
        '水平角度(ath)': location.ath.toFixed(2),
        '垂直角度(atv)': location.atv.toFixed(2),
      });
    },

    /**
     * 获取点击的坐标
     */
    getMouseLocation() {
      let mx = this.krpano.get("mouse.x");
      let my = this.krpano.get("mouse.y");
      let pnt = this.krpano.screentosphere(mx, my);
      let h = pnt.x;
      let v = pnt.y;
      return {
        ath: h,
        atv: v,
        x: mx,
        y: my,
      };
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  position: relative;
  width: 100%;
  height: 100%;
}
#pano {
  width: 100%;
  height: 100%;
}
</style>
